// extracted by mini-css-extract-plugin
module.exports = {"openingHoursContainer":"OpeningHours_openingHoursContainer__ckfdJ"};